import { useTranslation } from 'react-i18next';

interface DocumentTableHeaderProps {
  isAllSelected: boolean;
  onSelectAll: () => void;
}

export const DocumentTableHeader = ({ isAllSelected, onSelectAll }: DocumentTableHeaderProps) => {
  const { t } = useTranslation();

  return (
    <thead className="hidden lg:table-header-group">
      <tr className="border-b border-gray-200">
        <th className="w-12 px-4 py-3">
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={onSelectAll}
            className="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
          />
        </th>
        <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
          {t('documents.table.columns.name')}
        </th>
        <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
          {t('documents.table.columns.status')}
        </th>
        <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
          {t('documents.table.columns.opens')}
        </th>
        <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
          {t('documents.table.columns.update_date')}
        </th>
        <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
          {t('documents.table.columns.diffusion_date')}
        </th>
        <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
          {t('documents.table.columns.action')}
        </th>
        <th className="w-12 px-4 py-3"></th>
      </tr>
    </thead>
  );
};
